'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultConfig = function defaultConfig() {
  return {
    cookieName: 'zfc'
  };
};

var config = defaultConfig();

/**
 * Sets config back to its original state.
 * Used only for test purposes
 */
var resetConfig = exports.resetConfig = function resetConfig() {
  config = defaultConfig();
};

/**
 * Returns config variable if it exists
 * @param {String} name - name of config variable
 */
var getConfig = exports.getConfig = function getConfig(configName) {
  return config[configName];
};

/**
 * Sets config variable
 * @param {String} name - name of config variable
 * @param {String|Object} - value to store
 */
var setConfig = exports.setConfig = function setConfig(configName, configVal) {
  config[configName] = configVal;
};